export default {
  zh: {
   
  },
  en: {
    totalRe:"Total recharge",
    recordText:"Record",
    source:"Source",
    coin:"Coin",
    ruby:"Ruby",
  },
  ar: {
    totalRe:"إجمالي الشحن",
    recordText:"سِجِل",
    source:"مصدر",
    coin:"مصدر",
    ruby:"روبي",
  },
  tr: {
    totalRe:"Toplam Yükleme",
    recordText:"Kayıt",
    source:"Kaynak",
    coin:"Giriş",
    ruby:"Yakut",
  },
  pt:{
    "totalRe": "Recarga total",
    "recordText": "Registro",
    "source": "Fonte",
    "coin": "Moeda",
    "ruby": "Rubi"
    },
  id:{
    "totalRe": "Total isi ulang",
    "recordText": "Catatan",
    "source": "Sumber",
    "coin": "Koin",
    "ruby": "Ruby"
    },
  uz:{
    "totalRe": "Jami to'ldirish",
    "recordText": "Yozuv",
    "source": "Manba",
    "coin": "Tanga",
    "ruby": "Ruby"
    },
  ru:{
    "totalRe": "Общая пополнение",
    "recordText": "Запись",
    "source": "Источник",
    "coin": "Монета",
    "ruby": "Рубин"
    },
  fa:{
    "totalRe": "مجموع شارژ",
    "recordText": "سوابق",
    "source": "منبع",
    "coin": "سکه",
    "ruby": "یاقوت"
}





}



// WEBPACK FOOTER //
// src/pages/admin-control/bane-reset-userdata/lang.js